"use strict";
export class UIMenuItem {
  constructor(label) {
    this._visible = () => {
      return true;
    };
    this.label = label;
  }
  get command() {
    return this._action;
  }
  get isVisible() {
    if (!this._visible) {
      return true;
    }
    return this._visible();
  }
  action(action) {
    this._action = action;
    return this;
  }
  visible(visible) {
    this._visible = visible;
    return this;
  }
}
export class UIMenus extends Map {
  *menus() {
    for (const [name, menu] of this.entries()) {
      if (!menu.isVisible) {
        continue;
      }
      yield [name, menu];
    }
  }
  add(method, item) {
    this.set(method, item);
  }
  use(command) {
    return this.get(command);
  }
}
